function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 29.7",
    style: {
      enableBackground: "new 0 0 100 29.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "current"
    },
    d: "M19.5,13h-7.4v-5c0-1.4-0.1-2.3-0.2-2.7c-0.2-0.4-0.5-0.5-1-0.5c-0.6,0-1,0.2-1.2,0.7 C9.5,5.9,9.4,6.8,9.4,8.3v13.2c0,1.4,0.1,2.3,0.2,2.7s0.5,0.6,1.1,0.6c0.6,0,0.9-0.2,1.1-0.6c0.2-0.4,0.3-1.4,0.3-3v-3.6h7.4v1.1 c0,2.9-0.2,5-0.6,6.3c-0.4,1.2-1.3,2.3-2.8,3.2c-1.4,0.9-3.2,1.4-5.3,1.4c-2.2,0-4-0.4-5.4-1.2c-1.4-0.8-2.3-1.9-2.8-3.3 C2.2,23.8,2,21.8,2,19v-8.3C2,8.6,2.1,7.1,2.2,6c0.1-1,0.6-2,1.3-3c0.7-1,1.7-1.7,2.9-2.2C7.6,0.3,9,0,10.7,0c2.2,0,4,0.4,5.4,1.3 s2.4,1.9,2.8,3.2c0.4,1.3,0.7,3.2,0.7,5.9V13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "current"
    },
    d: "M20.9,0.6h5.2c3.5,0,5.9,0.1,7.1,0.4c1.2,0.3,2.2,1,3,2.1c0.8,1.1,1.2,2.9,1.2,5.3c0,2.2-0.3,3.7-0.8,4.5 c-0.6,0.8-1.6,1.2-3.3,1.4c1.5,0.4,2.5,0.9,3,1.5c0.5,0.6,0.8,1.2,0.9,1.7c0.1,0.5,0.2,1.9,0.2,4.2v7.5h-6.9v-9.5 c0-1.5-0.1-2.5-0.4-2.8c-0.2-0.4-0.9-0.5-1.9-0.5v12.8h-7.4V0.6z M28.3,5.5v6.3c0.8,0,1.4-0.1,1.8-0.3c0.3-0.2,0.5-1,0.5-2.2V7.7 c0-0.9-0.2-1.5-0.5-1.8C29.8,5.6,29.2,5.5,28.3,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "current"
    },
    d: "M40.5,0.6h12.4v5.7h-4.9v5.4h4.6v5.4h-4.6v6.3h5.4v5.7H40.5V0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "current"
    },
    d: "M77.8,0.6v28.5h-6.5l0-19.2l-2.6,19.2h-4.6l-2.7-18.8l0,18.8h-6.5V0.6h9.6c0.3,1.7,0.6,3.7,0.9,6.1l1.1,7.2 l1.7-13.3H77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "current"
    },
    d: "M93.7,0.6L98,29.1h-7.6L90,24h-2.6l-0.4,5.1h-7.7L83,0.6H93.7z M89.8,18.9c-0.4-3.2-0.8-7.2-1.1-12 c-0.8,5.5-1.2,9.4-1.4,12H89.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo_text.dd82378a8ad3b7c6ccc5832f46e2b301.svg";
export { ForwardRef as ReactComponent };